<template>
  <div class="container">
    <div class="centerall">
      <img
        src="@/assets/productIntroduction/5GTablet1.webp"
        alt="背景图"
        class="background-img"
      />
    </div>
    <div class="centerall1">
      <img
        src="@/assets/productIntroduction/5GTablet2.webp"
        alt="背景图"
        class="background-img"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}
.centerall {
  position: relative;
  width: 100%;
  max-width: 880px;
  height: 1048px;
  overflow: hidden;
}
.centerall1 {
  position: relative;
  width: 100%;
  max-width: 880px;
  height: 880px;
  margin-top: 50px;
  overflow: hidden;
}
@media (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .centerall {
    position: relative;
    width: 100%;
    height: 500px;
    overflow: hidden;
  }
  .centerall1 {
    position: relative;
    width: 100%;
    height: 350px;
    margin: 0;
    overflow: hidden;
  }
}
</style>
